var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bb-default-page-listen-content"},[_c('c-module-page-listen-content'),_vm._v(" "),_c('div',{class:{ 'pa-0 mb-3': _vm.$voicer.isDesktopOrTablet }},[_c('b-footer',{attrs:{"no-padding":_vm.$voicer.isDesktopOrTablet}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }